import { deleteRequest, getRequest, patchRequest, postRequest } from '../request/request.service';
import { OUTBOUND_API } from './outbound-calls.constants';
import {
  AvailabilityStatus,
  SalesAgent,
  SalesAgentPayload,
  SalespeopleResponse,
} from './salespeople.service.types';

const SALESPEOPLE_URL = `${OUTBOUND_API}/salespeople`;

export function getSalespeople(companyId: number) {
  return getRequest<SalespeopleResponse>(SALESPEOPLE_URL, { params: { company_id: companyId } });
}

export function createSalesAgent(companyId: number, payload: SalesAgentPayload) {
  return postRequest<SalesAgent>(SALESPEOPLE_URL, {
    params: { company_id: companyId },
    data: payload,
  });
}

export function updateSalesAgent(id: number, payload: SalesAgentPayload) {
  return patchRequest<SalesAgent>(`${SALESPEOPLE_URL}/${id}`, { data: payload });
}

export function deleteSalesAgent(id: number) {
  return deleteRequest<void>(`${SALESPEOPLE_URL}/${id}`);
}

/** The signed-in salesperson's own toggle; any role. 404 when the user is not one. */
export function setMyAvailability(status: AvailabilityStatus) {
  return postRequest<SalesAgent>(`${SALESPEOPLE_URL}/me/availability`, { data: { status } });
}
